<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="md"
		title="Restablecer la contraseña"
	>
		<b-form @submit="onSubmit">
			<b-form-group label="Nueva contraseña">
				<b-form-input
					v-model="model.password"
					type="password"
					required
				/>
			</b-form-group>
			<b-form-group label="Repetir contraseña">
				<b-form-input
					v-model="model.repeatPassword"
					type="password"
					required
				/>
			</b-form-group>
			<hr />
			<div class="text-center">
				<b-button
					v-if="!loadingUpdatePass"
					variant="primary"
					type="submit"
					>Actualizar contraseña</b-button
				>
				<b-button v-else disabled variant="primary" type="submit"
					><b-spinner small
				/></b-button>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			modelId: null,
			loading: false,
			loadingUpdatePass: false,
			model: {
				password: null,
				repeatPassword: null
			}
		};
	},

	methods: {
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.model.password === this.model.repeatPassword) {
				this.loading = true;
				this.$root.api
					.post(`users/${this.modelId}/reset-password`, {
						password: this.model.password
					})
					.then(() => {
						this.model.password = "";
						this.model.repeatPassword = "";
						this.loading = false;
						this.$root.showAlert('Contraseña actualizada correctamente');
						this.$refs["modal-view"].hide();
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.$root.showAlert('Las contraseñas son diferentes', {
					variant: "danger"
				});
			}
		}
	}
};
</script>

<style></style>
